'use client';

import { ComponentType } from 'react';

export interface IAction {
  Icon: ComponentType<{ className?: string }>;
  id: string;
  onClick: (id: string) => void;
}

/**
 * -----------------------------------------------------------------------------
 * It renders an action with an id, an onClick handler and an icon
 */
export function Action({ id, Icon, onClick }: Readonly<IAction>) {
  const handleOnClickAction = () => {
    onClick(id);
  };

  return (
    <button key={id} onClick={handleOnClickAction} type="button" value={id}>
      <Icon className="h-6 w-6" />
    </button>
  );
}
